<div class="game-data-node" (click)="onClick()">
	<div class="node-header">
		{{ getNodeTypeName() }}
		<button
			class="gear-button"
			(click)="onGearClick($event)"
			title="Edit settings"
		>
			<i class="bi bi-gear"></i>
		</button>
	</div>
	<div class="node-path text-small">[{{ data()?.path?.join(".") }}]</div>

	<handle type="target" position="left" />
	<handle type="source" position="right" />
</div>
